import { createSlice } from "@reduxjs/toolkit";
import {
  FETCH_PROJECTS_START,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_FAILURE,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAILURE,
} from "state/types/actionTypes";

const initialState = {
  projects: [],
  loading: false,
  error: null,
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    // Drop the current list and enter a loading state. Used when the active
    // workspace changes so the previous workspace's projects are never shown
    // (even briefly) before the new workspace's projects load.
    clearProjects(state) {
      state.projects = [];
      state.loading = true;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_PROJECTS_START, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FETCH_PROJECTS_SUCCESS, (state, action) => {
        state.projects = action.payload;
        state.loading = false;
      })
      .addCase(FETCH_PROJECTS_FAILURE, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(DELETE_PROJECT_SUCCESS, (state, action) => {
        // Deletion now runs in the background: the project still exists (with a
        // DeletionLock) until it finishes. Optimistically mark it as deleting rather
        // than removing it — removing it here would make the card vanish and then
        // reappear (a "blink") when the next fetch re-adds it as still-deleting. The
        // refetch/polling removes the card for good once the backend completes.
        state.projects = state.projects.map((project) =>
          project._id === action.payload
            ? { ...project, isDeleting: true }
            : project
        );
      })
      .addCase(DELETE_PROJECT_FAILURE, (state, action) => {
        // Update error state if deletion fails
        state.error = action.payload;
      });
  },
});

export const { clearProjects } = projectsSlice.actions;
export const projectsReducer = projectsSlice.reducer;
